/**
 * @file ServiceDailyReportPage.jsx
 * @description SERVICE department — Daily Report.
 *
 * Device-reported (CAN) events per day, service view.
 *
 * This file belongs to the SERVICE department. Departments never share page
 * files: each department's top-bar header mounts its OWN file (this one), so
 * a change for SERVICE is made HERE and can never leak into another
 * department's screens. The shared engine underneath (ServicePage) and the backend
 * stay common — only the department-facing page is departmental. Route access
 * is department-gated in utils/permissions.js: only SERVICE users (and the
 * super admin) can open it.
 */
import React from 'react';
import ServicePage from '../ServicePage';

const ServiceDailyReportPage = () => (<ServicePage forcedCat="DAILY_REPORT" />);

export default ServiceDailyReportPage;
